import * as React from "react";
import { Box, Avatar, Menu, MenuItem, ListItemIcon, Divider, IconButton, Tooltip } from "@mui/material";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import Logout from "@mui/icons-material/Logout";
// import { history } from "../helpers/history";
import SettingsDialog from "../Pages/SettingsDialog/SettingsDialog";
import { Link, useNavigate } from "react-router-dom";
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import { useDispatch } from "react-redux";
import { userActions } from '../actions/user.actions';
import Settings from "@mui/icons-material/Settings";
import { clearLocalData } from '../helpers/common';

export default function TopMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const childRef = React.useRef(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useState(()=>{
    if(localStorage.getItem('items_text_obj') == null){
      clearLocalData();
      dispatch(userActions.logoutRequest({}));
  
      navigate({
        pathname: "/logout",
        search: "?operation=logout",
      });
    }
  },[]);

  const logOutUser = () => {
    clearLocalData();
    dispatch(userActions.logoutRequest({}));

    navigate({
      pathname: "/logout",
      search: "?operation=logout",
    });
  };

  const showAlert = () => {
    handleClose();
    childRef.current.childFunction1();
  }

  return (
    <>
      <SettingsDialog ref={childRef} />
      <Box sx={{ display: "flex", alignitems: "center", textAlign: "center" }}>
        {/* <Typography sx={{ minWidth: 100 }}>Contact</Typography>
        <Typography sx={{ minWidth: 100 }}>Profile</Typography> */}
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }}></Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu className="menu-modal"
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        // onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* <MenuItem>
          <Avatar /> Profile
        </MenuItem>
        <MenuItem>
          <Avatar /> My account
        </MenuItem> */}
        <MenuItem className="settingMenu" onClick={showAlert}>         
          {/* <SettingsDialog /> */}
          <Settings fontSize="small" sx={{marginRight:"5px"}} /> Settings
        </MenuItem>
        <MenuItem sx={{display:"flex", alignItems:"center"}}>
          <Link to="/budgets" style={{display:"flex", alignItems:"center"}}>
            <ListOutlinedIcon fontSize="small" sx={{marginRight:"5px"}} />Budget
          </Link>
        </MenuItem>
        <MenuItem sx={{display:"flex", alignItems:"center"}}>
          <Link to="/tags" style={{display:"flex", alignItems:"center"}}>
            <ListOutlinedIcon fontSize="small" sx={{marginRight:"5px"}} />Tags
          </Link>
        </MenuItem>
        <MenuItem sx={{display:"flex", alignItems:"center"}}>
          <Link to="/accounts" style={{display:"flex", alignItems:"center"}}>
            <ListOutlinedIcon fontSize="small" sx={{marginRight:"5px"}} />Accounts
          </Link>
        </MenuItem>

        <Divider />
        <MenuItem>
          <Link to="/privacy-policy" className="df">
            <ArticleOutlinedIcon className="menu-icon" /> Privacy Policy
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to="/terms-conditions" className="df">
            <ArticleOutlinedIcon className="menu-icon" /> Terms & Conditions
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to="/faqs" className="df">
            <ArticleOutlinedIcon className="menu-icon" /> FAQs
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to="/contact-us" className="df">
            <ArticleOutlinedIcon className="menu-icon" /> Contact Us
          </Link>
        </MenuItem>
        <Divider />
        <MenuItem onClick={logOutUser}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}
